import { Loader2 } from "lucide-react";

export const PageLoader = () => (
  <div className="flex min-h-[50vh] items-center justify-center" role="status" aria-live="polite" data-testid="page-loader">
    <Loader2 className="h-6 w-6 animate-spin text-pink-500" aria-hidden />
    <span className="sr-only">Carregando…</span>
  </div>
);
